import React from "react";
import {IDropDownItemViewModel} from "../../models/item-model/drop-down-item-view-model.interface";
import {IDropDownListViewModel} from "../../models/list-model/drop-down-list-view-model.interface";
import styled, {css} from "styled-components";
import {DropDownItemComponent} from "../item/drop-down-item.component";
import {observer} from "mobx-react";
import {DropDownSearchComponent} from "./drop-down-search.component";
import {IDropDownController} from "../../drop-down-controller.interface";
import {useServices} from "../../../../hooks/use-services.hook";


const DropDownListContainerBox = styled.div<{isInMobileView: boolean}>`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-width: 100px;
    max-height: 200px;
    padding: 12px;
    
    ${
        props => props.isInMobileView 
                    ? css`
                          max-height: unset;
                          height: 100%;
                          width: 100%;
                    `
                    : ''
    }
`

const DropDownRowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
  height: 100%;
`

const EmptyListMessageContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    min-height: 100px;
`


interface DropDownListComponentProps<TItem extends IDropDownItemViewModel> {
    listViewModel: IDropDownListViewModel<TItem>;
    dropDownController: IDropDownController;
    renderEmptyListMessage?: () => React.ReactElement | string;
}


export const  DropDownListComponent = observer(<TItem extends IDropDownItemViewModel>(props: DropDownListComponentProps<TItem>) => {
    const services = useServices();
    const DropDownItem = DropDownItemComponent<TItem>;


    const renderItem = (item: TItem, index: number) => {
        return (
            <DropDownItem key={item.id}
                          index={index}
                          item={item}
                          listViewModel={props.listViewModel}/>
        );
    }

    const renderSearch = () => {
        if(props.listViewModel.shouldRenderSearchInDropDownList) {
            return (
                <DropDownSearchComponent listViewModel={props.listViewModel}
                                         dropDownController={props.dropDownController}/>
            )
        }

        return null;
    }

    const renderItems = () => {
        if(props.listViewModel.items.length === 0) {
            if(props.renderEmptyListMessage) {
                return (
                    <EmptyListMessageContainerBox>
                        {props.renderEmptyListMessage()}
                    </EmptyListMessageContainerBox>
                );
            } else {
                return null;
            }
        }

        return props.listViewModel.items.map(renderItem);
    }

    return (
        <DropDownListContainerBox isInMobileView={services.application.isInMobileView}>
            {renderSearch()}
            <DropDownRowsContainer>
                {renderItems()}
            </DropDownRowsContainer>
        </DropDownListContainerBox>
    )
});



